/**
 * Returns the latest timestamp (ms) from an object's keys that include "timestamp".
 * Accepts any object; only string-valued timestamp fields are used; non-string values are skipped.
 */
export const getLatestTimestamp = (
  obj: object | null | undefined
): number | null => {
  if (!obj || typeof obj !== "object") return null;
  const timestamps = Object.entries(obj as Record<string, unknown>)
    .filter(([key]) => key.includes("timestamp"))
    .map(([_, value]) =>
      typeof value === "string" ? new Date(value).getTime() : NaN
    )
    .filter((t) => !Number.isNaN(t));
  return timestamps.length ? Math.max(...timestamps) : null;
};
